import Config from "../config";

class WebService {
    API_URL = Config.ENVIRONMENTS[Config.ENVIRONMENT].API_URL
    BASE_IMG_PATH = Config.ENVIRONMENTS[Config.ENVIRONMENT].BASE_IMG_PATH;

    uploadMedia(formData, chatId, visitorId) {
        let body = new FormData();
        body.append("file", formData);

        return new Promise((resolve, reject) => {
            fetch(`${this.API_URL}/chat/upload/visitor?ChatId=${chatId}`, {
                method: "POST",
                credentials: "include",
                body,
                headers: {
                    SwiftSalesVisitorId: visitorId
                }
            })
                .then((res) => res.json())
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    }
}

export default WebService;
